import { useShallow } from 'zustand/shallow';
import { PermissionsStore, store } from './store';

export const useViewPermissions = () => {
  const { data, setPermissions, clearPermissions, isAdmin } =
    store<PermissionsStore>(
      useShallow((state) => ({
        data: state.data,
        setPermissions: state.setPermissions,
        clearPermissions: state.clearPermissions,
        isAdmin: state.isAdmin,
      })),
    );

  return {
    data,
    setPermissions,
    clearPermissions,
    isAdmin,
  };
};
